import { atom, onMount } from 'nanostores'
import NotificationsModel from '@app/models/notifications'
import { $realtime_enabled } from './realtime.stores'
import { getCustomerIdFromCurrentRoute } from '@client-shared/utils/users'

export const $notifications_count = atom(0)

export async function updateNotificationsCount(params: { is_realtime?: boolean }) {
	const { is_realtime = false } = params

	await NotificationsModel.getCount({ customer_id: getCustomerIdFromCurrentRoute(), is_realtime })

	$notifications_count.set(NotificationsModel.count)
}

/**
 * When the first subscriber to $notifications_count connects, we do an initial
 * fetch and start the refresh timer. The returned function runs after the last
 * subscriber disconnects and runs cleanup.
 *
 * Internally this subscribes to $realtime_enabled to listen for realtime state
 * changes. The subscription callback is fired immediately when it is registered
 * and then on all subsequent changes to $realtime_enabled.
 */
onMount($notifications_count, () => {
	let timer: NodeJS.Timeout | undefined

	const unsubscribe_fn = $realtime_enabled.subscribe(async (new_value, old_value) => {
		if (new_value === old_value) {
			return
		}

		updateNotificationsCount({ is_realtime: new_value })

		clearTimeout(timer)

		timer = setInterval(() => {
			updateNotificationsCount({ is_realtime: new_value })
		}, 30000)
	})

	return () => {
		clearTimeout(timer)
		unsubscribe_fn()
	}
})
